<!-- @author Amol, @date 29-08-2021, @description added assign batch plant company popup component-->
<div class="mainContent">

    <div style="height: 7vh;">
      <div>
        <label i18n="@@spmsUserReg" class="textColour" >Assign Dataset User Role</label>
        <span class="example-spacer"></span>
      </div>
    </div>

    <div style="height: 57vh;overflow: auto;padding-left: 4%;padding-right: 4%;">
      
        <div class="row" style="margin-top: 10px;">
          <div class="col-lg"> 
            <mat-form-field appearance="outline">
              <mat-label i18n="@@TMSTAFFMASTERfirstname">Dataset Name</mat-label>
              <input matInput type="text" placeholder="Dataset Name"
                     
                     [value]="assignUserRolePopupData.DatasetName"
                     
                     readonly>
            </mat-form-field>
          </div>
        </div>

        <div class="row" style="margin-top: 10px;">
          <div class="col-lg"> 
          <label>Grant Read-Only Access To </label>
          </div>
        </div>
         
        <div class="row" style="margin-top: 10px;"><!-- Removed the Private Radio Button -->
          <div class="col-lg" style="margin: 0 auto;">
              <mat-radio-button class="mat-checkbox-layout" [checked]="isPublic" (click)="toggleDropdownforpublic(true)">Public</mat-radio-button>
          </div>
          
          <div class="col-lg" style="margin: 0 auto; margin-left: 10px;"> <!-- Added margin-left -->
              <mat-radio-button class="mat-checkbox-layout"  [checked]="isRestricted" (click)="toggleDropdownforrestricted(true)">Restricted To</mat-radio-button>
          </div>
      </div>
      
      
      

      <div class="row topRowMargins">
        <div class="col-lg-12" style="text-align: center;">
        <div *ngIf="showDropdown" style="width: auto;">
          <mat-form-field appearance="outline">
            <mat-label i18n="@@RCFormulaexpression">User-Roles</mat-label>
            <mat-select [(ngModel)]="UserRoleAccessvalues" (selectionChange)="changeUseroles($event)" required multiple>
              <mat-option *ngFor="let option of Accesstypes" [value]="option[0]">
                {{ option[1] }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      </div>
  </div>
    
  
   
    <div style="height:5vh">
      <div class="row" style= "position:sticky;left:0;bottom:0;width:100%;">
  
        <div class="col-lg text-center">
  
          <div style="text-align: end;">
  
            <button i18n="@@TargetClear" type="button" (click)="updateData()"
                    class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton"
                    style="padding: .3rem 1.6rem;font-size: .85rem;width:95px;color: white;">Update</button>
  
            <button i18n="@@TargetCancel" type="button" (click)="close()"
                    class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton"
                    style="padding: .3rem 1.6rem;font-size: .85rem;width:95px;color: white;">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  
  
  

